//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ReadTime from '@/components/blog/ReadTime'
import PrevNextBlog from '@/components/blog/PrevNextBlog'

export default {
  name: 'PageSlug',

  components: {
    ReadTime,
    PrevNextBlog,
  },

  async asyncData({ $content, params }) {
    const post = await $content('blog', params.slug).fetch()
    const [prev, next] = await $content('blog')
      .only(['title', 'slug'])
      .sortBy('createdAt', 'asc')
      .surround(params.slug)
      .fetch()

    return { post, prev, next }
  },

  head() {
    return {
      title: this.post.title,
      titleTemplate: '%s - ArtForge',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.post.description,
        },
        // Open Graph
        { hid: 'og:title', property: 'og:title', content: this.post.title },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.post.description,
        },
        { hid: 'og:type', property: 'og:type', content: 'article' },

        // Twitter Card
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: this.post.title,
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.post.description,
        },

        {
          hid: 'og:image',
          property: 'og:image',
          content: this.post.img,
        },
        {
          hid: 'og:image:secure_url',
          property: 'og:image:secure_url',
          content: this.post.img,
        },
        {
          hid: 'og:image:alt',
          property: 'og:image:alt',
          content: this.post.title,
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: this.post.img,
        },
      ],
    }
  },
  methods: {
    formatDate(date) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' }
      return new Date(date).toLocaleDateString('en', options)
    },

    tweet() {
      const tweetURL =
        'https://twitter.com/intent/tweet?text=' +
        document.title +
        '&url=' +
        location.href
      window.open(tweetURL)
    },

    linkedInPost() {
      const linkedInPostURL =
        'https://www.linkedin.com/shareArticle/?mini=true&url=' + location.href
      this.PopupCenter(linkedInPostURL, 500, 500)
    },

    facebookPost() {
      const fbPostURL =
        'https://www.facebook.com/sharer/sharer.php?u=' +
        location.href +
        '&display=page'
      window.open(fbPostURL)
    },

    PopupCenter(url, w, h) {
      const dualScreenLeft =
        window.screenLeft !== undefined ? window.screenLeft : screen.left
      const dualScreenTop =
        window.screenTop !== undefined ? window.screenTop : screen.top

      const width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width
      const height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : screen.height

      const left = width / 2 - w / 2 + dualScreenLeft
      const top = height / 2 - h / 2 + dualScreenTop
      const newWindow = window.open(
        url,
        '_blank',
        'scrollbars=yes, width=' +
          w +
          ', height=' +
          h +
          ', top=' +
          top +
          ', left=' +
          left
      )

      // Puts focus on the newWindow
      if (window.focus) {
        newWindow.focus()
      }
    },
  },
}
